import { render, staticRenderFns } from "./DetailSidebar.vue?vue&type=template&id=67cbf2fb&scoped=true&"
import script from "./DetailSidebar.vue?vue&type=script&lang=js&"
export * from "./DetailSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DetailSidebar.vue?vue&type=style&index=0&id=67cbf2fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cbf2fb",
  null
  
)

export default component.exports